import React from "react";
import { useParams } from "react-router-dom";
import PageContent from "2g-page-content";

import ZadostDetailComponent from "b2b/components/zadost-detail/ZadostDetail";

export function ZadostDetail() {
  const { id } = useParams();

  return (
    <PageContent>
      <ZadostDetailComponent id={id} />
    </PageContent>
  );
}

ZadostDetail.propTypes = {};

export default React.memo(ZadostDetail);
